export const releaseInfo = {
    version: '414470f8',
}
